// colors
export const pinkMain = '#E00250';
export const pink1 = '#FDE6EE';
export const pink2 = '#FBCCDC';
export const pink3 = '#F799BA';
export const pink4 = '#F36697';
export const pink5 = '#EF3375';
export const pink6 = '#BC0042';
export const pink7 = '#8D0031';
export const pink8 = '#760029';
export const pink9 = '#5E0021';
export const pink10 = '#460019';

export const orangeMain = '#E32900';
export const orange1 = '#FCEAE6';
export const orange2 = '#F9D4CC';
export const orange3 = '#F4A999';
export const orange4 = '#EE7F66';
export const orange5 = '#E95433';
export const orange6 = '#B62100';
export const orange7 = '#881900';
export const orange8 = '#721500';
export const orange9 = '#5B1000';
export const orange10 = '#440C00';

export const blueMain = '#0073E6';
export const blue1 = '#E6F1FD';
export const blue2 = '#CCE3FA';
export const blue3 = '#99C7F5';
export const blue4 = '#66ABF0';
export const blue5 = '#338FEB';
export const blue6 = '#005CB8';
export const blue7 = '#00458A';
export const blue8 = '#003A73';
export const blue9 = '#002E5C';
export const blue10 = '#002245';

export const neutral1 = '#FFFFFF';
export const neutral2 = '#F8F8F8';
export const neutral3 = '#F2F2F2';
export const neutral4 = '#E5E5E5';
export const neutral5 = '#CCCCCC';
export const neutral6 = '#B2B2B2';
export const neutral7 = '#999999';
export const neutral8 = '#7F7F7F';
export const neutral9 = '#666666';
export const neutral10 = '#4C4C4C';
export const neutral11 = '#404040';
export const neutral12 = '#262626';
export const neutral13 = '#191919';
export const neutral14 = '#000000';

// gradients
export const gradientMain = 'linear-gradient(to right, #EB0052, #E32900)';
export const gradient1 = 'linear-gradient(to right, #BC0042, #B62100)';

// fonts
export const headerFont = "'Poppins', sans-serif";
export const bodyFont = "'Inter', sans-serif";